export default __webpack_public_path__ + "static/media/automotive.b59bc73a.png";